<template>
  <div>
    <div class="property-media-list" v-if="!fetchingMedia">
      <div class="d-md-block d-none mt-3">
        <div class="container-fluid plr-80">
          <div class="row">
            <div class="col-6 pr-1">
              <img
                class="main-image"
                @click="openGallery"
                :src="mainImageUrl"
                alt=""
              />
            </div>
            <div class="col-6 pl-1" v-if="propertyImages.length">
              <div class="row">
                <div
                  v-for="(item, idx) in propertyImages.slice(0, 4)"
                  :key="item.id"
                  class="col-6"
                  :class="{
                    'pt-2': [2, 3].includes(idx),
                    'pr-0': [0, 2].includes(idx),
                    'pl-2': [1, 3].includes(idx),
                  }"
                >
                  <div>
                    <img
                      @click="openGallery"
                      :src="item.url"
                      class="super-image"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 pt-2" v-if="propertyImages.length > 4">
              <div class="row">
                <div
                  v-for="(item, idx) in propertyImages.slice(4, 10)"
                  :key="item.id"
                  class="col-lg-2 position-relative"
                  :class="{
                    'pr-0': idx === 0,
                    'pl-0': idx === 5,
                    'pr-1': idx === 0,
                    'pl-1': idx === 5,
                    'px-1': ![0, 5].includes(idx),
                  }"
                >
                  <div v-if="idx === 5 && totalImages > totalImagesDisplayed">
                    <div
                      class="last-showing-photo"
                      :style="{ backgroundImage: `url(${item.url})` }"
                    ></div>
                    <div class="more-photo-link">
                      <span @click="openGallery">{{
                        $t("property.morePhotos", {
                          count: totalImages - totalImagesDisplayed,
                        })
                      }}</span>
                    </div>
                  </div>
                  <img
                    v-else
                    class="sub-image"
                    @click="openGallery"
                    :src="item.url"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-md-none d-block mt-3 px-0">
        <div class="container-fluid plr-80">
          <b-carousel
            id="carousel-fade"
            style="text-shadow: 0px 0px 2px #000"
            fade
            controls
            indicators
            img-width="1024"
            img-height="480"
          >
            <b-carousel-slide @click.native="openGallery" :img-src="mainImageUrl" />
            <b-carousel-slide
              v-for="image in propertyImages"
              :key="image.id"
              :img-src="image.url"
              @click.native="openGallery"
            />
          </b-carousel>
        </div>
      </div>
      <MediaGallery
        :propertyId="propertyId"
        :defaultMedia="propertyImages"
        ref="gallery"
      />
    </div>
    <div class="container-fluid plr-80" v-else>
      <MediaListSkeleton />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MediaGallery from "./MediaGallery.vue";
import MediaListSkeleton from "../Skeletons/MediaListSkeleton.vue";
export default {
  name: "MediaList",
  props: {
    propertyId: {
      type: Number,
      required: true,
    },
  },
  components: {
    MediaGallery,
    MediaListSkeleton,
  },
  data() {
    return {
      mainImageUrl: null,
      fetchingMedia: false,
      propertyImages: [],
      totalImages: 0,
    };
  },
  computed: {
    ...mapState("property", ["media", "propertyData"]),
    totalImagesDisplayed() {
      return this.propertyData.property?.mainUrl ? 10 : 11;
    },
  },
  methods: {
    ...mapActions("property", ["fetchPropertyMedia"]),
    openGallery() {
      if (this.propertyImages.length > 0) {
        this.$refs.gallery.show();
      }
    },
  },
  async mounted() {
    this.fetchingMedia = true;
    const data = await this.fetchPropertyMedia({
      propertyId: this.propertyId,
      params: { page: 1, perPage: 15 },
    });

    this.propertyImages = [...data.content];
    this.totalImages = data.totalElements;

    let mainImageUrl = this.propertyData.property?.mainUrl;

    if (!mainImageUrl && this.propertyImages.length > 0) {
      mainImageUrl = this.propertyImages.shift().url;
    }

    this.mainImageUrl = mainImageUrl || "/images/property-default-image.jpg";
    this.fetchingMedia = false;
  },
};
</script>

<style>
.main-image {
  width: 100%;
  height: calc(400px + 0.5rem);
  object-fit: cover;
  border-radius: 10px;
}
.super-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 10px;
}
.sub-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 10px;
}

.last-showing-photo {
  background-size: cover;
  background-position: center;
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 10px;
}

.last-showing-photo::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}

.more-photo-link {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.more-photo-link:hover {
  text-decoration: underline;
}

.property-media-list .carousel-item img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 10px;
}

@media (max-width: 767px) {
  .property-media-list .carousel-inner,
  .property-media-list .carousel-item {
    height: 250px;
  }
}
</style>
